export const SearchIcon = ({
  className,
  width = 11,
  height = 11,
  stroke = "#1E2330",
}: {
  className?: string;
  width?: number;
  height?: number;
  stroke?: string;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 11 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M7.39775 7.40555L10 10M8.5 4.75C8.5 6.82105 6.82105 8.5 4.75 8.5C2.67893 8.5 1 6.82105 1 4.75C1 2.67893 2.67893 1 4.75 1C6.82105 1 8.5 2.67893 8.5 4.75Z"
        stroke={stroke}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
